/* eslint-disable react/no-multi-comp */

import { RESERVE_TYPES } from 'constants'
import { FormattedMessage } from 'react-intl'
import React from 'react'

export const RESERVE_TOOLTIP_ID = 'clan_landing.reserve_tooltip'
export const NEW_RESERVE_TOOLTIP_ID = 'clan_landing.reserve_new_tooltip'

export const RESERVES_TO_SHOW = [
    RESERVE_TYPES.BATTLE_PAYMENTS,
    RESERVE_TYPES.MILITARY_MANEUVERS,
    RESERVE_TYPES.TACTICAL_TRAINING,
    RESERVE_TYPES.ADDITIONAL_BRIEFING,
]

export const MODIFIER_CLAN_LANDING = 'clanLanding'

export const HEADER_MESSAGE = (
    <FormattedMessage
        id='clan_landing.reserves.header'
        defaultMessage='Клановые резервы'
    />
)

export const COMMANDER_TOOLTIP_TEXT = (
    <FormattedMessage
        id='clan_landing.reserves.commanderTooltip'
        defaultMessage='Нажмите, чтобы перейти к выбору и активации клановых резервов.'
    />
)

export const BOXES_COUNT = 2



// WEBPACK FOOTER //
// ./containers/ClanLanding/components/ClanLandingReserves/constants.js